import { FC } from "react";
import {useNavigation} from "./useNavigation";
import {Icon} from "assets/Icon";
import {Link} from "react-router-dom";
import "./Navigation.scss";

type NavigationProps = {
    callback?: () => void
}

export const Navigation: FC<NavigationProps> = ({callback}) => {
    const { items } = useNavigation(callback);

    return (
        <div className="Navigation">
            {items.map((item, i) => (
                <Link key={`nav-${i}`} className={`Navigation-item${item.isActive ? ' active' : ''}`} to={item.link}>
                    <Icon name={item.icon} isActive={item.isActive} hasUnread={item?.hasUnread} />
                    <span>{item.name}</span>
                </Link>
            ))}
        </div>
    )
}